// extracted by mini-css-extract-plugin
export default {"ordersboard":"OrdersBoard_ordersboard__QXdFi","orders":"OrdersBoard_orders__eKk0h","orderNumber":"OrdersBoard_orderNumber__FCqLi"};